export default __webpack_public_path__ + "static/stanleyknife-5ae8f9c271c2d65aaa4040e13892d046.png";